<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar a embalagem <b>{{this.entry.name}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(packaging) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_PACKAGING_MUTATION,
          variables: {
            id: packaging.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyPackaging.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_PACKAGING_MUTATION = gql `
  mutation($id: ID!) {
    destroyPackaging(id: $id) {
      packaging {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>